import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pie-chart",
  "use": "icon-pie-chart-usage",
  "viewBox": "0 0 490.279 490.279",
  "content": "<symbol viewBox=\"0 0 490.279 490.279\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pie-chart\"><g><path d=\"m490.279 241.126c.077 62.274-24.67 122.01-68.763 165.986l-165.986-165.986v-234.761c129.629-.02 234.729 105.049 234.749 234.678z\" fill=\"#ef5261\" /><path d=\"m395.821 416.002c-90.549 90.55-237.359 90.55-327.908.001s-90.55-237.359-.001-327.908c43.485-43.485 102.464-67.914 163.961-67.912v231.872z\" fill=\"#f6c863\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pie-chart.svg
// module id = lSig
// module chunks = 102